module.exports = __webpack_public_path__ + "static/media/icon-star-primary.a1493b1d.svg";